import React from 'react';
import { Box, Center, Flex, Spinner, Text } from '@chakra-ui/react';
import { BranchesFilters } from './branchesFilters';
import { CardBranch } from './cardBranch';
import { useBranchFilters } from '../hooks/useBranchesFilters';
import { PaginatorFooter } from '../../../components/PaginatorFooter';

export const BranchesTab = () => {
  const { results, loading, nextPage, prevPage, search } = useBranchFilters();

  return (<>
      <Flex direction="column" height="100%">
        <BranchesFilters onUpdateFilters={search} />

        {loading && <Center marginTop="xxl"><Spinner /></Center>}

        {results && !loading &&
          <>
            <Box flexGrow="1" marginBottom="xl" overflowY="auto" paddingX="xl">
              {results.content && results.content.length > 0 ?
                results.content.map((branch) => <CardBranch key={branch.id} marginBottom="xl" branch={branch} />)
                :
                <Text>No hay sucursales disponibles.</Text>
              }
            </Box>

            <Box marginTop="auto" position="sticky" bottom="0">
              <PaginatorFooter
                pageable={results.pageable}
                total_elements={results.total_elements}
                onPreviousPage={prevPage}
                onNextPage={nextPage} />
            </Box>
          </>
        }
      </Flex>
    </>
  );
};
